<template>
  <OverlayCard width="m" @cancel="$emit('cancel')">
    <template #title>{{ $t('projectSettings.deleteProject') }} "{{ project.name }}"</template>

    <template #content>
      <div v-html="$t('projectSettings.deleteProjectDescription')" />

      <InputBox
        :label="$t('projectSettings.deleteProjectLabel')"
        :placeholder="$t('projectSettings.deleteProjectPlaceholder')"
        v-model="projectName"
        required
        test-id="project-delete-input-name"
      />
    </template>

    <template #footer>
      <ButtonLoading
        :is-disabled="projectName !== project.name && status !== 2"
        color="destructive"
        @click="deleteProject"
        :status="status"
        data-test-id="project-delete-submit"
      >
        {{ $t('projectSettings.deleteProjectCta') }}
      </ButtonLoading>

      <Btn
        shortcut="cancel"
        color="grey"
        @click="$emit('cancel')"
        :disabled="status === 2"
        data-test-id="project-delete-cancel"
      >
        {{ $t('action.cancel') }}
      </Btn>
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ProjectEvent } from '@/tracking/trackingTypes';
import { Project } from '@/types';

import { Status } from './common/ButtonLoading.vue';

export default defineComponent({
  name: 'DeleteProjectCard',

  props: {
    project: {
      type: Object as PropType<Project>,
      required: true,
    },
  },

  emits: { cancel: null },

  data() {
    return {
      projectName: '',
      status: Status.Idle,
    };
  },

  methods: {
    deleteProject() {
      this.status = Status.Loading;

      const message = this.$t('notification.projectSuccessfullyDeleted', { name: this.project.name });

      this.$store.dispatch('project/delete', { id: this.project.id, name: this.project.name }).then(() => {
        this.$store.dispatch('notification/add', {
          message,
          undo: () => this.$store.dispatch('project/restore', { id: this.project.id }),
        });

        this.$tracker.track(ProjectEvent.ProjectDeleted);

        this.$store.dispatch('modal/hide', { type: 'projectDelete' });
      });
    },
  },
});
</script>
